import React, {useEffect, useState} from "react";
import {DarkModeIconSVG, LightModeIconSVG} from "./icons";

export const DarkMode = () => {

    const [icon, setIcon] = useState(<DarkModeIconSVG size={34}/>);

    const [darkMode, setDarkMode] = useState();

    const root = window.document.documentElement;

    useEffect(() => {
        if(localStorage.getItem('theme')) {
            toggleDarkMode(true);
        }
    }, []);

    const toggleDarkMode = (mode) => {
        if (mode) {
            localStorage.theme = 'dark';
            setIcon(<LightModeIconSVG size={34} color={"#1dff73"}/>);
            root.classList.add("dark");
            setDarkMode(true);
        }
        else{
            localStorage.removeItem('theme')
            setIcon(<DarkModeIconSVG size={34}/>);
            root.classList.remove("dark");
            setDarkMode(false);
        }
    }

    return (
        <button className="px-3" onClick={() => {return toggleDarkMode(!darkMode)}} aria-label="darkModeToggler">{icon}</button>
    )
}
